import React from 'react';
import { compose } from 'ramda';
import styleFile from './header.js';

import { Button } from '@synergycms_core/components/generic';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { Image } from '@synergycms_core/components/generic';


const HeaderLogo = compose(withThemeJSS({ styleFile, displayName: 'Header' }))((props) => {
  const { classes } = props.theme.styles;
  const urlHome = (window.CMSElementLangURLs || []).find((item) => item.code === props.langCode?.toUpperCase())?.url_home || window.location.origin;

  return (
    <Button
      onClick={() => {
        return (window.location.href = urlHome);
      }}
      ariaLabel={'eurostarsLogo2025'}>
      <Image svg={'eurostarsLogo2025'} alt={'header_logo'} innerStyle={classes.headerLogo} />
    </Button>
  );
});


export default HeaderLogo;
